// @ts-ignore
/* eslint-disable */
import { request } from 'src/utils/request';
import qs from 'qs';

/**  GET /api/v1/device/thing-model/property-device */
export async function getThingModelPropertyDevice(
  data?: { search_type?: string; range?: number[]; device_ids?: string[]; code?: string[]; isAll?: boolean; page?: number; pageSize?: number },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/device/thing-model/property-device`, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
    // params: { ...params },
    ...(options || {}),
  });
}

export async function getThingModelExportData(
  data?: { search_type?: string; range?: number[]; device_ids?: string[]; code?: string[]; isAll?: boolean; page?: number; pageSize?: number },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/device/thing-model/export-data`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
    data,
    // params: { ...params },
    ...{ ...options, isFile: true },
  });
}

export async function getAllProducts(params?: { isAll?: boolean }, options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/v1/products', {
    method: 'GET',
    params: { ...params },
    ...(options || {}),
  });
}

export async function getProductDetail(params?: { id?: string }, options?: { [key: string]: any }) {
  return request<Record<string, any>>(`/api/v1/product/${params?.id}`, {
    method: 'GET',
    // params: { ...params },
    ...(options || {}),
  });
}
export async function getAllDevices(params?: { isAll?: boolean; product_id?: string }, options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/v1/devices', {
    method: 'GET',
    params: { ...params },
    ...(options || {}),
  });
}
